"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var ValueWithUnitConverter_1 = require("../../core/conversions/ValueWithUnitConverter");

var ProductFlag_1 = require("../model/ProductFlag");

var ProductInfo_1 = require("../model/ProductInfo");

var ProductInfoConverter_1 = require("./ProductInfoConverter");
/**
 * Default implementation of ProductConverter.
 *
 * @author Jaroslav Sevcik
 */


var ProductInfoConverterImpl =
/*#__PURE__*/
function (_ProductInfoConverter) {
  _inherits(ProductInfoConverterImpl, _ProductInfoConverter);

  function ProductInfoConverterImpl() {
    _classCallCheck(this, ProductInfoConverterImpl);

    return _possibleConstructorReturn(this, _getPrototypeOf(ProductInfoConverterImpl).apply(this, arguments));
  }

  _createClass(ProductInfoConverterImpl, [{
    key: "toObject",

    /**
     * @inheritDoc
     */
    value: function toObject(source, conversions) {
      return new ProductInfo_1.ProductInfo(ProductInfo_1.ProductInfo.schema.id.valueOf(conversions.documentToClassId(source)), ProductInfo_1.ProductInfo.schema.externalId.valueOfField(source), ProductInfo_1.ProductInfo.schema.name.valueOfField(source), ProductInfo_1.ProductInfo.schema.familyId.valueOf(conversions.toClassReferenceId(source.familyId)), ProductInfo_1.ProductInfo.schema.categoryIds.valueOf(conversions.asClassReferenceIdsList(source, 'categoryIds')), ProductInfo_1.ProductInfo.schema.productSensitivityId.valueOf(conversions.toClassReferenceId(source.productSensitivityId)), ProductInfo_1.ProductInfo.schema.tierId.valueOf(conversions.toClassReferenceId(source.tierId)), conversions.asFlagSet(source.flags, ProductFlag_1.ProductFlag), ProductInfo_1.ProductInfo.schema.supplierId.valueOf(conversions.toClassReferenceId(source.supplierId)), ProductInfo_1.ProductInfo.schema.measureUnitId.valueOf(conversions.toClassReferenceId(source.measureUnitId)), conversions.asObject(source, 'packageSize', ValueWithUnitConverter_1.ValueWithUnitConverter.deserialize(conversions)));
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "toDocument",
    value: function toDocument(source, conversions) {
      if (typeof source !== 'object' || source === null) {
        return null;
      }

      var result = {};
      Object.assign(result, conversions.classToDocumentId(source));
      Object.assign(result, {
        externalId: source.externalId,
        name: source.name,
        familyId: conversions.toDocumentReferenceId(source.familyId),
        categoryIds: conversions.asObjectArray(source, 'categoryIds', function (id) {
          return conversions.toDocumentReferenceId(id);
        }),
        productSensitivityId: conversions.toDocumentReferenceId(source.productSensitivityId),
        tierId: conversions.toDocumentReferenceId(source.tierId),
        flags: source.flags.serialize(),
        supplierId: conversions.toDocumentReferenceId(source.supplierId),
        measureUnitId: conversions.toDocumentReferenceId(source.measureUnitId),
        packageSize: conversions.asObject(source, 'packageSize', ValueWithUnitConverter_1.ValueWithUnitConverter.serialize(conversions))
      });
      return result;
    }
  }]);

  return ProductInfoConverterImpl;
}(ProductInfoConverter_1.ProductInfoConverter);

exports.ProductInfoConverterImpl = ProductInfoConverterImpl;